export default function Request(client, responseBus) {
    const queued = [];
    let count = 0;

    client.onReady(() => {
        queued.forEach(req =>
            client.send(req.id, req.destination, req.headerLocale, req.headers, req.body)
        );
        queued.splice(0, queued.length);
    });

    this.get = (destination, callback, headers, body, headerLocale) => {
        const id = ++count;
        responseBus.addHandler(id, callback);

        if (client.isReady()) {
            client.send(id, destination, headerLocale, headers, body);
        } else {
            queued.push({
                id: id,
                destination: destination,
                headerLocale: headerLocale,
                headers: headers,
                body: body,
            });
        }
    };
}
